import {View} from "@lernetz/ts-lib";
import {gateway} from "../../services/gateway";
import {ColumnLayout, ColumnLayoutView} from "./article-elements/column-layout/column-layout.component";
import {Column, ColumnView} from "./article-elements/column-layout/column.component";
import {Contact, ContactView} from "./article-elements/contact/contact.component";
import template from "./generic.component.html";

export class GenericPage extends View {
    constructor() {
        super({template});
        this.registry.add( Column, () => new ColumnView())
        this.registry.add( ColumnLayout, () => new ColumnLayoutView())
        this.registry.add( Contact, () => new ContactView())
    }
}

export class GenericPageController {
    content: any;
    general: any;
    routeInit(slug: string) {
        gateway.loadPage(slug).then( res => {
            this.content = res;
        });
        gateway.loadGeneralInfos().then(generalInfos => {
            this.general = generalInfos;
        });
    }
}
